import styled from 'styled-components';

import { mediaTopBarHidden, mediaTopBarVisible } from '@xing-com/layout-tokens';
import { scale040, scale060, scale110 } from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

export const StyledHeadline = styled(Headline)`
  padding-top: ${scale040};
`;

export const ProductsWrapper = styled.div`
  position: relative;
  padding-bottom: ${scale110};
  top: ${scale060};
`;

export const StyledTitle = styled.p<{
  $hideTitleOnSmallerScreens: boolean;
}>`
  margin: 0;
  text-decoration: none;
  text-align: left;
  white-space: nowrap;

  @media ${mediaTopBarVisible} {
    display: none;
  }

  @media ${mediaTopBarHidden} {
    display: ${({ $hideTitleOnSmallerScreens }) =>
      $hideTitleOnSmallerScreens ? 'none' : 'block'};
  }
`;
